import { render, staticRenderFns } from "./NoticiasGuru.vue?vue&type=template&id=59fe54a2&scoped=true"
import script from "./NoticiasGuru.vue?vue&type=script&lang=js"
export * from "./NoticiasGuru.vue?vue&type=script&lang=js"
import style0 from "./NoticiasGuru.vue?vue&type=style&index=0&id=59fe54a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fe54a2",
  null
  
)

export default component.exports